import { Hero } from "../sections/Hero";
import { FeaturedWork } from "../sections/FeaturedWork";
import { About } from "../sections/About";
import { Experience } from "../sections/Experience";
import { AdditionalProjects } from "../sections/AdditionalProjects";
import { Contact } from "../sections/Contact";

export function Home() {
  return (
    <main id="main-content" tabIndex={-1}>
      <Hero />
      <FeaturedWork />
      <About />
      <Experience />
      <AdditionalProjects />
      <Contact />
    </main>
  );
}
